export const TOKEN_COOKIE = {
  cookieName: '_token',
  password: process.env.USER_SESSION_TOKEN,
  cookieOptions: {
    secure: process.env.NODE_ENV === 'production',
    maxAge: 43200, // 12 hours,
    path: '/',
  },
};

export const getClientCookie = name => document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
